import AccountTreeOutlinedIcon from '@mui/icons-material/AccountTreeOutlined';
import AssignmentTurnedInOutlinedIcon from '@mui/icons-material/AssignmentTurnedInOutlined';
import BugReportOutlinedIcon from '@mui/icons-material/BugReportOutlined';
import CloudOutlinedIcon from '@mui/icons-material/CloudOutlined';
import ComputerOutlinedIcon from '@mui/icons-material/ComputerOutlined';
import DashboardOutlinedIcon from '@mui/icons-material/DashboardOutlined';
import DescriptionOutlinedIcon from '@mui/icons-material/DescriptionOutlined';
import FlashOnOutlinedIcon from '@mui/icons-material/FlashOnOutlined';
import GavelOutlinedIcon from '@mui/icons-material/GavelOutlined';
import GroupOutlinedIcon from '@mui/icons-material/GroupOutlined';
import PolicyOutlinedIcon from '@mui/icons-material/PolicyOutlined';
import SearchOutlinedIcon from '@mui/icons-material/SearchOutlined';
import SecurityOutlinedIcon from '@mui/icons-material/SecurityOutlined';
import TrackChangesOutlinedIcon from '@mui/icons-material/TrackChangesOutlined';
import type { CSSProperties, FC, ReactNode } from 'react';

export type SecurityNavIconColors = {
  active: string;
  inactive: string;
};

const SECURITY_NAV_ICON_COMPONENTS: Record<string, FC<{ style?: CSSProperties }>> = {
  'security-operations-center': SecurityOutlinedIcon,
  'reseller-dashboard': DashboardOutlinedIcon,
  'sub-org-dashboard': DashboardOutlinedIcon,
  clients: GroupOutlinedIcon,
  endpoints: ComputerOutlinedIcon,
  'configuration-compliance': AssignmentTurnedInOutlinedIcon,
  'malware-detection': BugReportOutlinedIcon,
  'automated-response': FlashOnOutlinedIcon,
  'file-integrity-monitoring': DescriptionOutlinedIcon,
  'threat-hunting': SearchOutlinedIcon,
  'vulnerability-detection': PolicyOutlinedIcon,
  'mitre-attck': TrackChangesOutlinedIcon,
  'pci-dss': GavelOutlinedIcon,
  gdpr: PolicyOutlinedIcon,
  hipaa: SecurityOutlinedIcon,
  'nist-800-53': AccountTreeOutlinedIcon,
  tsc: AssignmentTurnedInOutlinedIcon,
  'google-cloud': CloudOutlinedIcon,
  'office-365': CloudOutlinedIcon,
};

const resolveIconColor = (active: boolean | undefined, colors: SecurityNavIconColors): string =>
  active ? colors.active : colors.inactive;

const getNavIconStyle = (
  active: boolean | undefined,
  colors: SecurityNavIconColors
): CSSProperties => ({
  fontSize: 20,
  color: resolveIconColor(active, colors),
  flexShrink: 0,
});

export const renderSecurityNavIcon = (
  id: string,
  active: boolean | undefined,
  colors: SecurityNavIconColors
): ReactNode => {
  const Icon = SECURITY_NAV_ICON_COMPONENTS[id] ?? SecurityOutlinedIcon;
  return <Icon style={getNavIconStyle(active, colors)} />;
};

/** Show a divider after this nav item id (separates primary EDR links from feature pages). */
export const SECURITY_NAV_DIVIDER_AFTER = new Set(['endpoints']);
